import zhLocale from './zh_CN';
export default zhLocale;
